import { connect } from 'react-redux';

// types
import { Dispatch } from 'types/dispatch';
import { State } from 'widgets/free-content/root/root.reducers';
import { ILoadingManagerHOCStoreProps } from 'modules/loading-manager/loading-manager.types';

// container
import LoadingManager from 'modules/loading-manager';

// actions
import { Actions as IPLocationActions } from 'modules/IP-location/index';
import { Actions as LanguageProviderActions } from 'modules/language-provider';
import { Actions as UbisoftConnectActions } from 'modules/ubisoft-connect-provider';
import { Actions as UbisoftConnectOverlayActions } from 'modules/ubisoft-connect-overlay-provider';

const { fetchInitialLanguage } = LanguageProviderActions;
const { IPLocationFetchData } = IPLocationActions;
const { loadUbisoftConnect } = UbisoftConnectActions;
const { loadUbisoftConnectOverlay } = UbisoftConnectOverlayActions;

const mapStateToProps = (state: State): ILoadingManagerHOCStoreProps => ({
    mode: state.config.mode,
    shouldInheritStyles: state.config.shouldInheritStyles
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    actions: {
        modeAgnostic: [
            () => dispatch(fetchInitialLanguage()),
            () => dispatch(IPLocationFetchData()),
            () => dispatch(loadUbisoftConnect()),
            () => dispatch(loadUbisoftConnectOverlay())
        ],
        standalone: [
        ]
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LoadingManager);
